export enum DoorType {
  Turn,
  Slide,
}
